import { useContext } from "react"
import languageContext from "../contexts/languageContext"

const useLanguageContext = () => {
    return useContext(languageContext)
}

export default useLanguageContext